import React, { Component } from 'react'
import {connect} from 'react-redux';

function withMedia(WrappedComponent){
    class MediaQuery extends Component {
        render() {
            return (
                <WrappedComponent {...this.props} />
            ) 
        }
    }
    return connect( 
        (state, ownProps) =>({
            browser: state.browser,
        }),
        dispatch => { 
            return { } 
        }
    )(MediaQuery);
}

export default withMedia



// WEBPACK FOOTER //
// ./src/containers/withmedia/index.js